<div class="row animated fadeIn">
    <div class="col-md-12">
        <div class="row justify-content-between align-items-center mb-2 zIndexUp">
            <h4 class="col-xl-auto col-lg-auto col-md-6 col-sm-6 mb-lg-0 mb-sm-2 mb-md-2 mb-2">Task</h4>
            <ul
                class="list-unstyled action-tool-bar col-xl-auto col-lg-auto col-md-10 col-sm-12 mb-0 d-flex align-items-center flex-wrap">
                <li *ngIf="permission.Task_Filter==1 || userRId==1">
                    <a href="javascript:void(0);" class="btn btn-sm btn-light-info bg-info border-info"
                        (click)="openClosefun()"><span class="mdi mdi-filter"></span>
                        Filter
                    </a>
                </li>
                <li *ngIf="permission.Task_Add==1 || userRId==1">
                    <a href="javascript:void(0);" routerLink="/Task/AddTask" class="btn btn-sm btn-light-info"><span
                            class="mdi mdi-plus"></span>
                        Add Task
                    </a>
                </li>
            </ul>
        </div>

        <div class="card mt-3" *ngIf="isCollapsed">
            <div class="card-body cb-pad-adjust">
                <form [formGroup]="registerForm">
                    <div class="form-row">
                        <div class="col-xl-2 col-lg-6 col-md-6 mb-2">
                            <small class="same-height-label-1">Project Name (Project ID)</small>
                            <angular2-multiselect formControlName="ProjectName" [data]="Project1"
                                [(ngModel)]="selectedProject" [settings]="dropdownProject"
                                (onSelect)="onProject($event)">
                            </angular2-multiselect>
                        </div>

                        <div class="col-xl-2 col-lg-6 col-md-6 mb-2">
                            <small class="same-height-label-1">Inquiry Name (Inquiry ID)</small>
                            <angular2-multiselect formControlName="InquiryName" [data]="InquiryId"
                                [(ngModel)]="selectedInquiryId3" [settings]="dropdownInquiry"
                                (onSelect)="onInquiryIdSelect($event)" (onDeSelectAll)="onInquiryIdSelect($event)">
                            </angular2-multiselect>
                        </div>

                        <div class="col-xl-2 col-lg-6 col-md-6 mb-2">
                            <small class="same-height-label-1">Task Status</small>
                            <angular2-multiselect formControlName="TaskStatus" [data]="TaskStatus1"
                                [(ngModel)]="selectedStatus" [settings]="dropdownTaskStatus"
                                (onSelect)="onStatusSelect($event)">
                            </angular2-multiselect>
                        </div>

                        <div class="col-xl-2 col-lg-6 col-md-6 mb-2">
                            <small class="same-height-label-1">Task Priority</small>
                            <angular2-multiselect formControlName="TaskPriorityName" [data]="TaskPriority1"
                                [(ngModel)]="selectedPriority" [settings]="dropdownTaskPriority"
                                (onSelect)="onPrioritySelect($event)">
                            </angular2-multiselect>
                        </div>

                        <div class="col-xl-2 col-lg-6 col-md-6 mb-2">
                            <small class="same-height-label-1">Assigned To</small>
                            <angular2-multiselect formControlName="AssignedToUserName" [data]="AssignedTo1"
                                [(ngModel)]="selectedAssignedTo" [settings]="dropdownAssignedTo"
                                (onSelect)="onAssignedToSelect($event)">
                            </angular2-multiselect>
                        </div>

                        <div class="col-xl-2 col-lg-6 col-md-6 mb-2">
                            <small class="same-height-label-1">Task Title</small>
                            <angular2-multiselect formControlName="Taskitile" [data]="TaskTitile1"
                                [(ngModel)]="selectedTitle" [settings]="dropdownTaskTitile"
                                (onSelect)="onTitleSelect($event)" (onDeSelect)="onTitleSelect($event)"
                                (onSelectAll)="onTitleSelect($event)" (onDeSelectAll)="onTitleSelect($event)">
                            </angular2-multiselect>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="col-xl-2 date-filter-field-1 col-lg-6 col-md-6 mb-2">
                            <small class="d-flex align-items-center"><input type="checkbox" formControlName="CheckStart"
                                    class="mr-1 cursor-pointer" /> Start Date</small>
                            <div class="input-group">
                                <div class="w-100">
                                    <input class="form-control" type="text" [showDropdowns]="true" ngxDaterangepickerMd
                                        [(ngModel)]="date_range" [settings]="dropdownSettings"
                                        [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges"
                                        (keydown)="disableDate()" [showClearButton]="true" placeholder="Select Range"
                                        [ngModelOptions]="{standalone: true}" />

                                </div>
                            </div>
                        </div>
                        <div class="col-xl-2 date-filter-field-1 date-filter-second-last-field col-lg-6 col-md-6 mb-2">
                            <small class="d-flex align-items-center"><input type="checkbox" formControlName="CheckEnd"
                                    class="mr-1 cursor-pointer" /> End Date</small>
                            <div class="input-group">
                                <div class="w-100">
                                    <input class="form-control" type="text" [showDropdowns]="true" ngxDaterangepickerMd
                                        [(ngModel)]="date_range2" [settings]="dropdownSettings2"
                                        [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges"
                                        (keydown)="disableDate()" [showClearButton]="true" placeholder="Select Range"
                                        [ngModelOptions]="{standalone: true}" />
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-xl-2 date-filter-field-1 date-filter-last-field col-lg-6 col-md-6  mb-3 mb-md-2">
                            <small class="d-flex align-items-center"><input type="checkbox"
                                    formControlName="CheckCreate" class="mr-1 cursor-pointer" /> Created Date</small>
                            <div class="input-group">
                                <div class="w-100">
                                    <input class="form-control" type="text" [showDropdowns]="true" ngxDaterangepickerMd
                                        [(ngModel)]="date_range3" [settings]="dropdownSettings3"
                                        [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges"
                                        (keydown)="disableDate()" [showClearButton]="true" placeholder="Select Range"
                                        [ngModelOptions]="{standalone: true}" />
                                </div>
                            </div>
                        </div>

                        <div class="col-auto mb-2 mb-md-0">
                            <small class="same-height-label-1 d-none d-md-block"> &nbsp; </small>
                            <a href="javascript:void(0);"
                                class="btn btn-outline-info d-flex align-items-center btn-new-light-info" title="Apply"
                                (click)="onSubmit()">
                                <i class="mdi mdi-checkbox-marked-outline mdi-18px"></i> Apply
                            </a>
                        </div>

                        <div class="col-auto mb-2 mb-md-0">
                            <small class="same-height-label-1 d-none d-md-block"> &nbsp; </small>
                            <a href="javascript:void(0);"
                                class="btn btn-outline-info d-flex align-items-center btn-new-light-info" title="Reset"
                                (click)="resetData()">
                                <i class="mdi mdi-reload mdi-18px"></i>
                            </a>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <mat-form-field class="example-full-width pb-0 w-100 form-control-design1" appearance="fill"
                        style="width: 250px !important; float: right;">
                        <input #inputField matInput class="text-limit  pos-search" [(ngModel)]="searchword"
                            placeholder="Search" (keyup.enter)="applyFilter()" />
                        <span class="mdi mdi-magnify mdi-2x cursor-pointer " title="Search"
                            style="position: absolute;right: 0;font-size: 20px;color: #999;top: 0;"
                            (click)="applyFilter();"></span>
                        <span class="position-absolute" style="top: 50%; right: 7%; transform: translate(-50%, -50%);"
                            title="Clear">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                class="bi bi-x" viewBox="0 0 16 16" (click)="clearUserData(); applyFilter()"
                                (clearEvent)="searchword=''" *ngIf="searchword">
                                <path
                                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                            </svg>
                        </span>
                    </mat-form-field>
                    <table class="table" mat-table matSorts [dataSource]="dataSource" matSort [matSortActive]="'name'"
                        [matSortDisableClear]="true" [matSortDirection]="'asc'" [multiTemplateDataRows]="true"
                        (matSortChange)="onSortData($event)" aria-hidden="true">

                        <ng-container matColumnDef="TaskId">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width:115px;max-width:200px;">Task ID<img src="assets/images/sort_both.png"
                                    *ngIf="columnsort!='TaskId'" alt=""><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='TaskId'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='TaskId'"></th>
                            <td mat-cell *matCellDef="let element"><a href="javascript:void(0);"
                                    (click)="view(element.TaskId)">{{element['TaskNumber']}}</a></td>
                        </ng-container>

                        <!-- Weight Column -->
                        <ng-container matColumnDef="ProjectName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width: 140px;max-width:200px;">PROJECT NAME
                                (PROJECT ID) <img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort!='ProjectName'"><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='ProjectName'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='ProjectName'"></th>
                            <td mat-cell *matCellDef="let element">
                                <div *ngIf="element['ProjectNumber']!='' && element['ProjectNumber']!=null">
                                    {{element['ProjectName']}} ({{element['ProjectNumber']}})
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="InquiryId">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                style="min-width: 140px;max-width:200px;">Inquiry name
                                (Inquiry ID)<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort!='InquiryId'"><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='InquiryId'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='InquiryId'"></th>
                            <td mat-cell *matCellDef="let element">
                                <div *ngIf="element['InquiryNumber']!='' && element['InquiryNumber']!=null">
                                    {{element['InquiryName']}} ({{element['InquiryNumber']}})
                                </div>
                            </td>
                        </ng-container>
                        <!-- Symbol Column -->

                        <ng-container matColumnDef="TaskTitile">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-nowrap">Task title<img
                                    src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='TaskTitile'"><img
                                    src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='TaskTitile'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='TaskTitile'"></th>
                            <td mat-cell style="min-width:150px" *matCellDef="let element">
                                <div class="truncate_description w-100 overflow-hidden">
                                    {{element['TaskTitleName']}}
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="TaskDiscription">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-nowrap1"
                                style="max-width: 200px; min-width: 120px;">Task
                                Description<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort!='TaskDiscription'"><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='TaskDiscription'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='TaskDiscription'"></th>
                            <td mat-cell *matCellDef="let element">
                                <div class="truncate_description1 w-100 overflow-hidden">
                                    {{element['TaskDescription']}}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="TaskStatus">
                            <th style="min-width: 130px" mat-header-cell *matHeaderCellDef mat-sort-header> Task
                                Status<img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort!='TaskStatus'"><img src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='TaskStatus'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='TaskStatus'"></th>
                            <td mat-cell *matCellDef="let element"> {{element['TaskStatusName']}} </td>
                        </ng-container>

                        <ng-container matColumnDef="TaskPriority">
                            <th style="min-width: 160px;" mat-header-cell *matHeaderCellDef mat-sort-header> Task
                                Priority<img src="assets/images/sort_both.png" *ngIf="columnsort!='TaskPriority'" alt=""><img
                                    src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='TaskPriority'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='TaskPriority'"></th>
                            <td mat-cell *matCellDef="let element">
                                <span [style.background]=" element['ColourCode']"
                                    style="font-size:12px;color: white;padding:3px 10px; border-radius:12px;"
                                    *ngIf="element['TaskPriorityName']=='P1- Blocker'">
                                    {{element['TaskPriorityName']}}</span>
                                <span [style.background]=" element['ColourCode']"
                                    style="font-size:12px;color: white;padding:3px 10px; border-radius:12px;"
                                    *ngIf="element['TaskPriorityName']=='P2-Critical'">
                                    {{element['TaskPriorityName']}}</span>
                                <span style="font-size:12px;color: white;padding:3px 10px; border-radius:12px;"
                                    [style.background]=" element['ColourCode']"
                                    *ngIf="element['TaskPriorityName']=='P3-High Importance'">
                                    {{element['TaskPriorityName']}}</span>
                                <span
                                    style="width:155px;display:block;text-align: center;font-size:12px;color: #444;padding:3px 10px; border-radius:12px;"
                                    [style.background]=" element['ColourCode']"
                                    *ngIf="element['TaskPriorityName']=='P4-Medium Importance'">
                                    {{element['TaskPriorityName']}}</span>
                                <span [style.background]=" element['ColourCode']"
                                    style="text-align: center;width:155px;display:block;font-size:12px;color: white;padding:3px 10px; border-radius:12px;"
                                    *ngIf="element['TaskPriorityName']=='P5-Low Importance'">{{element['TaskPriorityName']}}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="StartDate">
                            <th style="min-width: 90px;max-width: 90px" mat-header-cell *matHeaderCellDef
                                mat-sort-header> Start
                                Date<img src="assets/images/sort_both.png" *ngIf="columnsort!='StartDate'" alt=""><img
                                    src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='StartDate'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='StartDate'"></th>
                            <td mat-cell *matCellDef="let element">{{element['StartDate']}} </td>
                        </ng-container>

                        <ng-container matColumnDef="EndDate">
                            <th style="min-width: 90px;max-width: 90px" mat-header-cell *matHeaderCellDef
                                mat-sort-header>End Date <img src="assets/images/sort_both.png" alt=""
                                    *ngIf="columnsort!='EndDate'"><img src="assets/images/sort_up.png"
                                    *ngIf="upicon && !downicon && columnsort =='EndDate'" alt=""><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='EndDate'"></th>
                            <td mat-cell *matCellDef="let element">{{element['EndDate']}} </td>
                        </ng-container>

                        <ng-container matColumnDef="AssignedTo">
                            <th style="min-width: 130px" mat-header-cell *matHeaderCellDef mat-sort-header>Assigned To
                                <img src="assets/images/sort_both.png" *ngIf="columnsort!='AssignedTo'" alt=""><img
                                    src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='AssignedTo'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='AssignedTo'">
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element['AssignedToUserName']}} </td>
                        </ng-container>

                        <ng-container matColumnDef="CreatedDate">
                            <th style="min-width: 90px;max-width: 90px" mat-header-cell *matHeaderCellDef
                                mat-sort-header>Created Date
                                <img src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='CreatedDate'"><img
                                    src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='CreatedDate'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='CreatedDate'">
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element['CreatedDate']}} </td>
                        </ng-container>

                        <ng-container matColumnDef="Createdby">
                            <th style="min-width: 130px" mat-header-cell *matHeaderCellDef mat-sort-header>Created
                                By<img src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='Createdby'"><img
                                    src="assets/images/sort_up.png" alt=""
                                    *ngIf="upicon && !downicon && columnsort =='Createdby'"><img
                                    src="assets/images/sort_down.png" alt=""
                                    *ngIf="downicon && !upicon && columnsort =='Createdby'"></th>
                            <td mat-cell *matCellDef="let element"> {{element['CreatedByUserName']}} </td>
                        </ng-container>

                        <ng-container matColumnDef="Action">
                            <th mat-header-cell *matHeaderCellDef><span class="mdi mdi-settings"></span></th>
                            <td mat-cell *matCellDef="let element">
                                <div ngbDropdown class="d-block list-dropdown-box">
                                    <a href="javascript:void(0);" class="text-center d-block" id="dropdownBasic1"
                                        ngbDropdownToggle> <i class="mdi mdi-dots-vertical mdi-24"></i></a>
                                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right">
                                        <div class="d-block">
                                            <div
                                                *ngIf="(userRId == 1 || userid == element.CreatedBy || userid == element.AssignedTo) && (element.TaskStatus!=6 && element.TaskStatus!=7) && (permission.Task_Edit==1)">
                                                <a href="javascript:void(0);" class="" placement="bottom"
                                                    (click)="edit(element.TaskId)"><button ngbDropdownItem><i
                                                            class="mdi mdi-pencil"></i>
                                                        Edit</button></a>
                                            </div>
                                            <div
                                                *ngIf="userRId == 1 || (element.TaskStatus!=6 && element.TaskStatus!=7 && userid == element.CreatedBy) && (permission.Task_Delete==1)">
                                                <a href="javascript:void(0);" class="" placement="bottom"
                                                    (click)="deleteOpenModal(deleteConfirm,element,3)"><button
                                                        ngbDropdownItem><i class="mdi mdi-delete"></i>
                                                        Delete</button></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <tr class="odd" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <div *ngIf="TotalRecord == 0" class="text-center">
                        No Record found.
                    </div>
                    <div *ngIf="TotalRecord > 0">
                        <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50, 100]" [length]="totalSize"
                            showFirstLastButtons aria-label="Select page of periodic elements" [pageIndex]="currentPage"
                            (page)="handlePage($event)" [pageSize]="pageSize">
                        </mat-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Delete modal-->
<ng-template #deleteConfirm>
    <div class="modal-header">
        <h4 class="modal-title text-dark"><strong>Task Delete</strong></h4>
        <button type="button" class="close" (click)="decline(); modalRef.hide();" data-dismiss="modal"
            aria-label="Close"><span aria-hidden="true">&times;</span></button>
    </div>
    <div class="modal-body text-center">
        <p class="text-left mb-2"><strong>Task_Number -{{file}}</strong></p>
        <p class="text-left mb-2">Do you want to delete this Task ?</p>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-danger btn-sm" (click)="deleteTask(); modalRef.hide();"
            [disabled]="delNameDel">Delete</button>
        <button type="button" class="btn btn-sm btn btn-secondary ml-2"
            (click)="decline(); modalRef.hide();">Cancel</button>
    </div>
</ng-template>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>